import * as React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { canopy } from "./../theme";

const Tab = ({ icon, label, active, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 0.5,
      color: active ? canopy.green : canopy.faint,
      cursor: "pointer",
      minWidth: 72,
      py: 0.5,
    }}
  >
    {icon}
    <Typography sx={{ fontSize: 12, fontWeight: active ? 800 : 700 }}>{label}</Typography>
  </Box>
);

// Mobile bottom navigation for signed-in residents (Canopy design)
export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  if (!user?.uid) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "flex", md: "none" },
        alignItems: "center",
        justifyContent: "space-around",
        px: 3,
        pt: 1,
        pb: "max(12px, env(safe-area-inset-bottom))",
        bgcolor: "background.paper",
        borderTop: `1px solid ${canopy.border}`,
        zIndex: (t) => t.zIndex.appBar,
      }}
    >
      <Tab
        icon={<HomeOutlinedIcon />}
        label="Home"
        active={location.pathname.startsWith("/account")}
        onClick={() => navigate("/account")}
      />
      <Tab
        icon={<CreditCardIcon />}
        label="Autopay & cards"
        active={location.pathname.startsWith("/profile")}
        onClick={() => navigate("/profile")}
      />
    </Box>
  );
}
